import {createTheme} from "@mui/material";

const theme = createTheme({
    palette: {
        primary: {
            main:  '#fefefe'
        }
    },
    typography: {
        fontFamily: [
            "covesLight",
            "covesBold",
            "sans-serif"
        ].join(",")
    }
});

export default theme;
